// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * POC animated lobby — global CSS hooks on existing components.
 * Every rule is scoped under html[data-fx="1"] (stamped by MotionTierManager when ?fx=1), so with the
 * flag off nothing here matches. Hook classes are one-shots added by shared/effects/oneShot.ts and
 * removed on animationend; attributes on <html> are stamped for a fixed window and removed.
 * transform / opacity only, finite, no will-change.
 */
/* Favorite toggle: a heart pop on the button. */
html[data-fx='1'] .egt_game_btn_favorite.fx-pop {
  animation: fxHeartPop 300ms cubic-bezier(0.2, 0.9, 0.3, 1.4);
}
@keyframes fxHeartPop {
  0% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.45);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
/* First-load reveal: the navigation bar rises in behind the curtain. */
html[data-fx='1'][data-fx-reveal] .egt_navigation_container {
  animation: fxNavIn 520ms cubic-bezier(0.2, 0.8, 0.2, 1) 350ms both;
}
@keyframes fxNavIn {
  from {
    transform: translateY(24px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
/* View switch: the container that just became visible crossfades in. */
html[data-fx='1'] [data-section-container].fx-view-in {
  animation: fxViewIn 260ms ease-out;
}
html[data-motion-tier='lite'] [data-section-container].fx-view-in {
  animation-duration: 160ms;
}
@keyframes fxViewIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Ambient nav light sweep: one band element, transform only, driven by WAAPI (shared/effects/NavSweep.tsx). */
html[data-fx='1'] .fx-sweep-clip {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  border-radius: inherit;
}
html[data-fx='1'] .fx-sweep-band {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 28%;
  background: linear-gradient(100deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.09) 50%, rgba(255, 255, 255, 0) 100%);
  transform: translateX(-120%);
}
/* Tier off (also prefers-reduced-motion): the hooks render nothing. */
html[data-motion-tier='off'] .fx-pop,
html[data-motion-tier='off'] .fx-view-in,
html[data-motion-tier='off'][data-fx-reveal] .egt_navigation_container {
  animation: none;
}
`, "",{"version":3,"sources":["webpack://./src/shared/effects/fx.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF,gDAAgD;AAChD;EACE,4DAA4D;AAC9D;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;AACA,uEAAuE;AACvE;EACE,kEAAkE;AACpE;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA,uEAAuE;AACvE;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA,8GAA8G;AAC9G;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,UAAU;EACV,0HAA0H;EAC1H,4BAA4B;AAC9B;AACA,sEAAsE;AACtE;;;EAGE,eAAe;AACjB","sourcesContent":["/**\n * POC animated lobby — global CSS hooks on existing components.\n * Every rule is scoped under html[data-fx=\"1\"] (stamped by MotionTierManager when ?fx=1), so with the\n * flag off nothing here matches. Hook classes are one-shots added by shared/effects/oneShot.ts and\n * removed on animationend; attributes on <html> are stamped for a fixed window and removed.\n * transform / opacity only, finite, no will-change.\n */\n/* Favorite toggle: a heart pop on the button. */\nhtml[data-fx='1'] .egt_game_btn_favorite.fx-pop {\n  animation: fxHeartPop 300ms cubic-bezier(0.2, 0.9, 0.3, 1.4);\n}\n@keyframes fxHeartPop {\n  0% {\n    transform: scale(1);\n  }\n  40% {\n    transform: scale(1.45);\n  }\n  70% {\n    transform: scale(0.9);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n/* First-load reveal: the navigation bar rises in behind the curtain. */\nhtml[data-fx='1'][data-fx-reveal] .egt_navigation_container {\n  animation: fxNavIn 520ms cubic-bezier(0.2, 0.8, 0.2, 1) 350ms both;\n}\n@keyframes fxNavIn {\n  from {\n    transform: translateY(24px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n/* View switch: the container that just became visible crossfades in. */\nhtml[data-fx='1'] [data-section-container].fx-view-in {\n  animation: fxViewIn 260ms ease-out;\n}\nhtml[data-motion-tier='lite'] [data-section-container].fx-view-in {\n  animation-duration: 160ms;\n}\n@keyframes fxViewIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Ambient nav light sweep: one band element, transform only, driven by WAAPI (shared/effects/NavSweep.tsx). */\nhtml[data-fx='1'] .fx-sweep-clip {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  border-radius: inherit;\n}\nhtml[data-fx='1'] .fx-sweep-band {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 28%;\n  background: linear-gradient(100deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.09) 50%, rgba(255, 255, 255, 0) 100%);\n  transform: translateX(-120%);\n}\n/* Tier off (also prefers-reduced-motion): the hooks render nothing. */\nhtml[data-motion-tier='off'] .fx-pop,\nhtml[data-motion-tier='off'] .fx-view-in,\nhtml[data-motion-tier='off'][data-fx-reveal] .egt_navigation_container {\n  animation: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
